export function computeOdooProductCostInCurrency(data, targetCurrency) {
  if (!data) return {};
  const odooProducts = JSON.parse(data.odooProducts);
  const odooCurrencies = JSON.parse(data.odooActiveCurrencies);

  let res = {};
  const odooCurrency = odooCurrencies.find((i) => i.name === targetCurrency);
  if (!odooCurrency) return res;

  const odooCurrencyRate = parseFloat(odooCurrency.rate);

  odooProducts.forEach((product) => {
    const productCost = parseFloat(product.standard_price);
    const productCostCurrencyId = product.cost_currency_id[0];
    const productCostCurrency = odooCurrencies.find(
      (i) => i.id === productCostCurrencyId,
    );
    if (!productCostCurrency) return;
    const productCostCurrencyRate = parseFloat(productCostCurrency.rate);
    const productCostInTargetCurrency =
      (productCost / productCostCurrencyRate) * odooCurrencyRate;
    res[product.id] = productCostInTargetCurrency;
  });

  return res;
}
